<template lang="html">
  <div class="w-full">
		<div class="w-full">
			<small class="block">{{$t('hotel')}}</small>
			
			<v-select 
			:placeholder='placeh' 
			:append-to-body="append_to_body" 
			class="sm:w-full lg:w-1/3 select-hotel vue-select" 
			:clearable="clear" 
			v-model="temp_current_stay" 
			:reduce="item => item.id" 
			v-on:input="$emit('onChangeHotel', temp_current_stay)" 
			:options="hotel_list_axios" 
			label="name" :multiple='multi' 
			:closeOnSelect="closeOnS">

				<span slot="no-options">{{$t('vSelectNoResults')}}</span>
			</v-select>
			<vs-button v-if="menus_page" class="md:ml-3 -py-5 lg:mt-0 mt-4" color="primary" v-on:click="$emit('createMenu')">{{$t('newo')}}</vs-button>
		</div>
  </div>
</template>

<script>

export default {
	props: ['current_stay', 'menus_page', 'append_to_body', 'clearable', 'multiple', 'placeholder', 'closeOnSelect', 'extra_hotels', 'reload'],
	data() {
		return {
			hotel_list_axios: [],
			default_hotel: '',
			temp_current_stay: '',
		}
	},
	methods: {
		getHotels() {
			if(this.reload){
            	localStorage.removeItem('hotels');
			}
			let hotels_tmp = JSON.parse(localStorage.getItem('hotels'));
			
			if(hotels_tmp !== null) {
				this.$vs.loading.close();
				this.hotel_list_axios = hotels_tmp;
				this.temp_current_stay = this.current_stay;
				return;
			}
			this.$vs.loading();
			let token = this.$user !== null ? this.$user.usertoken : process.env.VUE_APP_TOKEN;
			let that = this;
			
			this.$api({
				method: 'get',
				url: '/myvilagale/get_hotels',
				params: {
					token: token,
					extra_hotels: (typeof this.extra_hotels !== 'undefined') ? this.extra_hotels : [0] // 0 to return no result
				}
			})
			.then(function (res) {
				that.$vs.loading.close();
				that.hotel_list_axios = res.data;
				if(localStorage.getItem('hotels') === null && !that.reload) {
					localStorage.setItem('hotels', JSON.stringify(res.data));
				}
				that.temp_current_stay = that.current_stay;
			})
			.catch ( function (err) {
				that.$vs.loading.close();
				that.failure_message = that.$t('Erro_a_obter_hoteis');
			})
		},	
	},
	computed: {
		clear: function(){
			return typeof this.clearable !== 'undefined';
		},
		multi: function(){
			return typeof this.multiple !== 'undefined';
		},
		closeOnS: function(){
			return typeof this.closeOnSelect === 'undefined';
		},
		placeh: function(){
			if(typeof this.placeholder !== 'undefined'){
				return this.placeholder;
			}
			return '';
		},
	},
	watch: {
    	'current_stay': function(valor) {
	        this.temp_current_stay = valor;
    	}
    },
	created: function() {
		this.getHotels();
	}
}

</script>
<style scoped>
	.vue-select {
		display: inline-block;
	}
	@media (max-width: 767.98px) {
		.vue-select {
			display: block;
		}	
	}
</style>